const BUS_EVENT = "xbyte-business-selection-request";

export function requestBusinessSelection(detail) {
  window.dispatchEvent(new CustomEvent(BUS_EVENT, { detail }));
}

export function subscribeBusinessSelection(handler) {
  const h = e => handler?.(e.detail);
  window.addEventListener(BUS_EVENT, h);
  return () => window.removeEventListener(BUS_EVENT, h);
}
